/**
 * Fragment de routes du paquet v1-p07-compte (vague V1), actif sans condition depuis le retrait du drapeau
 * `navigationV10` (R3, 02/11). Composants chargés à la demande (règle de chargement du registre).
 * Routes neuves (aucune route du socle n'est remplacée) : les YAML des six écrans n'ont pas de `couvre: route:`.
 *  - `/compte` → transverse-mon-compte ; `/compte/preferences` → transverse-preferences ;
 *  - dialogues en écran plein : `/compte/conditions`, `/compte/confirmer-identite?action=…`,
 *    `/compte/jetons/nouveau` (confirmation transmise par l'état de navigation), `/compte/delegation`.
 */
import { lazy, Suspense, type ComponentType, type JSX } from 'react'

import type { Session } from '../../auth/session'
import type { ContexteRoutes, FragmentRoutes } from './registre'

const MonCompte = lazy(() => import('../ecrans/v1/compte/MonCompte'))
const Preferences = lazy(() => import('../ecrans/v1/compte/Preferences'))
const DialogueAccepterConditions = lazy(() => import('../ecrans/v1/compte/DialogueAccepterConditions'))
const DialogueConfirmerIdentite = lazy(() => import('../ecrans/v1/compte/DialogueConfirmerIdentite'))
const DialogueCreerJeton = lazy(() => import('../ecrans/v1/compte/DialogueCreerJeton'))
const DialogueDeleguerProfils = lazy(() => import('../ecrans/v1/compte/DialogueDeleguerProfils'))

function ecran(Composant: ComponentType<{ session: Session }>) {
  return ({ session, t }: ContexteRoutes): JSX.Element => (
    <Suspense fallback={<p role="status">{t('v10.primitives.assemblage.chargement')}</p>}>
      <Composant session={session} />
    </Suspense>
  )
}

export const fragment: FragmentRoutes = {
  zone: 'v1-compte',
  routes: [
    { chemin: '/compte', element: ecran(MonCompte) },
    { chemin: '/compte/preferences', element: ecran(Preferences) },
    { chemin: '/compte/conditions', element: ecran(DialogueAccepterConditions) },
    { chemin: '/compte/confirmer-identite', element: ecran(DialogueConfirmerIdentite) },
    { chemin: '/compte/jetons/nouveau', element: ecran(DialogueCreerJeton) },
    { chemin: '/compte/delegation', element: ecran(DialogueDeleguerProfils) },
  ],
}
